import { trackSelfDescribingEvent } from "@snowplow/browser-tracker";

import { DeliveryEstimateContext } from "../types";

export function emitDeliveryEstimate({
  postcode,
  labelType,
  label,
  shortLabel = null,
  timestamp = null,
  minRange = null,
  maxRange = null,
  confidence,
  parcelType,
  deliveryType,
}: DeliveryEstimateContext["options"]) {
  trackSelfDescribingEvent({
    event: {
      schema: "iglu:au.com.catch/delivery_estimate/jsonschema/1-0-0",
      data: {
        postcode,
        labelType,
        label,
        shortLabel,
        timestamp,
        minRange,
        maxRange,
        confidence,
        parcelType,
        deliveryType,
      },
    },
  });
}
